var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricsEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 354.887,
    height: 245.71,
    viewBox: "0 0 354.887 245.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "metrics_raw",
    "data-name": "metrics raw",
    transform: "translate(-81.556 -61.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4215",
    "data-name": "Group 4215",
    transform: "translate(67.554 61.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4000",
    "data-name": "Group 4000",
    transform: "translate(221.851 173.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4971",
    "data-name": "Path 4971",
    d: "M-.119,15.161H23.2a2.97,2.97,0,0,0,2.971-2.971V5.007A5.006,5.006,0,0,0,21.162,0H-.3Z",
    transform: "translate(0.295)",
    fill: "#d1f1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4001",
    "data-name": "Group 4001",
    transform: "translate(196.846 188.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4972",
    "data-name": "Path 4972",
    d: "M-32.54,4.519H-78.389A2.259,2.259,0,0,1-80.648,2.26,2.259,2.259,0,0,1-78.389,0H-32.54a2.259,2.259,0,0,1,2.259,2.26A2.259,2.259,0,0,1-32.54,4.519",
    transform: "translate(80.648)",
    fill: "#d1f1fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4002",
    "data-name": "Group 4002",
    transform: "translate(183.803 127.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4973",
    "data-name": "Path 4973",
    d: "M-4.03-100.82l25.223-.446L37.2-40.756l-34.15.343L-9.817-93.461a5.955,5.955,0,0,1,1.106-5.085A5.955,5.955,0,0,1-4.03-100.82",
    transform: "translate(9.988 101.266)",
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4003",
    "data-name": "Group 4003",
    transform: "translate(206.767 192.762) rotate(99.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4974",
    "data-name": "Path 4974",
    d: "M.753,4.378h44.5L44.9,2.341,0,0Z",
    fill: "#d1f1fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4004",
    "data-name": "Group 4004",
    transform: "translate(224.561 192.761) rotate(100.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4975",
    "data-name": "Path 4975",
    d: "M.8,4.37H45.385l-.372-2.034L0,0Z",
    fill: "#d1f1fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4005",
    "data-name": "Group 4005",
    transform: "translate(239.618 191.891) rotate(78.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4976",
    "data-name": "Path 4976",
    d: "M.888,0H45.65l-.413,2.026L0,4.353Z",
    fill: "#d1f1fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4006",
    "data-name": "Group 4006",
    transform: "translate(212.097 127.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4977",
    "data-name": "Path 4977",
    d: "M0-101.547,12.483-40.973h9.573L12.045-94.5a8.62,8.62,0,0,0-8.476-7.05Z",
    transform: "translate(0 101.547)",
    fill: "#d1f1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4007",
    "data-name": "Group 4007",
    transform: "translate(250.822 147.95)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711",
    "data-name": "Rectangle 1711",
    width: 34.523,
    height: 1.679,
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4008",
    "data-name": "Group 4008",
    transform: "translate(263.779 149.477) rotate(-75.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4978",
    "data-name": "Path 4978",
    d: "M6.793,26.045H31.909L24.958,0,0,.591Z",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4009",
    "data-name": "Group 4009",
    transform: "translate(265.966 126.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4979",
    "data-name": "Path 4979",
    d: "M0,21.308H24.081L29.687,0H5.481Z",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4010",
    "data-name": "Group 4010",
    transform: "translate(245.725 237.842) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712",
    "data-name": "Rectangle 1712",
    width: 1.744,
    height: 83.241,
    fill: "#75d5ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4011",
    "data-name": "Group 4011",
    transform: "translate(247.469 237.842) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713",
    "data-name": "Rectangle 1713",
    width: 1.744,
    height: 83.003,
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4012",
    "data-name": "Group 4012",
    transform: "translate(353.137 237.842) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1714",
    "data-name": "Rectangle 1714",
    width: 1.744,
    height: 83.241,
    fill: "#75d5ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4013",
    "data-name": "Group 4013",
    transform: "translate(354.883 237.842) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715",
    "data-name": "Rectangle 1715",
    width: 1.744,
    height: 83.003,
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4014",
    "data-name": "Group 4014",
    transform: "translate(368.889 156.592) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716",
    "data-name": "Rectangle 1716",
    width: 132.435,
    height: 6.828,
    fill: "#75d5ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4015",
    "data-name": "Group 4015",
    transform: "translate(352.269 167.893) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717",
    "data-name": "Rectangle 1717",
    width: 58.302,
    height: 11.3,
    fill: "#e0f3fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4016",
    "data-name": "Group 4016",
    transform: "translate(323.118 162.762) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4980",
    "data-name": "Path 4980",
    d: "M1.3,2.6A1.3,1.3,0,1,1,2.6,1.3,1.3,1.3,0,0,1,1.3,2.6",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4018",
    "data-name": "Group 4018",
    transform: "translate(37.413 71.927) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1719",
    "data-name": "Rectangle 1719",
    width: 35.812,
    height: 55.394,
    transform: "translate(-13 -166)",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4019",
    "data-name": "Group 4019",
    transform: "translate(24.51 53.265) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720",
    "data-name": "Rectangle 1720",
    width: 9.854,
    height: 18.071,
    transform: "translate(-13 -166)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4033",
    "data-name": "Group 4033",
    transform: "translate(139.775 181.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4985",
    "data-name": "Path 4985",
    d: "M-2.34-15.8a15.291,15.291,0,0,1,9.482-1.152,7.88,7.88,0,0,1,4.684,2.091c1.17,1.292,1.392,3.567.048,4.676a4.491,4.491,0,0,1-2.953.75C6.415-9.459,3.633-9.9,1.631-8.393.489-7.532-.272-6.1-1.638-5.679A3.229,3.229,0,0,1-5.191-7.26a5.52,5.52,0,0,1-.4-4.074A6.219,6.219,0,0,1-2.34-15.8",
    transform: "translate(5.798 17.214)",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4034",
    "data-name": "Group 4034",
    transform: "translate(134.96 144.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4986",
    "data-name": "Path 4986",
    d: "M-1.127,22.4c1.764,2.519,5.191,1.685,6.781.148s2.261-3.766,2.873-5.891c1.4-4.857,2.8-9.957,1.767-14.9a8.28,8.28,0,0,0-1.9-4.049A4.322,4.322,0,0,0,4.3-3.652C2.567-3.2,1.493-1.5.717.108A35.5,35.5,0,0,0-2.792,15.343,12.312,12.312,0,0,0-1.127,22.4",
    transform: "translate(2.792 3.763)",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4035",
    "data-name": "Group 4035",
    transform: "translate(111.471 152.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4987",
    "data-name": "Path 4987",
    d: "M-13.739,19.06a9.168,9.168,0,0,0,1.426-8.435,16.258,16.258,0,0,0-5-7.246A26.9,26.9,0,0,0-26.253-1.9a9.557,9.557,0,0,0-4.023-.683A4.222,4.222,0,0,0-33.653-.539c-.941,1.795-.039,3.973.938,5.749a68.155,68.155,0,0,0,5.875,8.947c1.762,2.271,3.779,4.51,6.463,5.536s5.471.9,6.9-.956",
    transform: "translate(34.05 2.609)",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036",
    transform: "translate(136.474 185.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4988",
    "data-name": "Path 4988",
    d: "M-.022,23.174a5.48,5.48,0,0,0,.16-1.145c.081-.833.183-1.878.3-3.123a45.173,45.173,0,0,1,.7-4.582A35.321,35.321,0,0,1,2.81,8.916,19.947,19.947,0,0,1,5.571,4.023a10.314,10.314,0,0,1,3.491-2.9A9.764,9.764,0,0,1,12,.206,5.523,5.523,0,0,0,13.141.041a5.324,5.324,0,0,0-1.16-.018,8.911,8.911,0,0,0-3.065.8A10.284,10.284,0,0,0,5.234,3.749,19.459,19.459,0,0,0,2.371,8.74a33.087,33.087,0,0,0-1.654,5.5,38.736,38.736,0,0,0-.609,4.64c-.1,1.327-.137,2.4-.154,3.143a5.356,5.356,0,0,0,.024,1.155",
    transform: "translate(0.054 -0.011)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037",
    transform: "translate(136.474 154.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4989",
    "data-name": "Path 4989",
    d: "M-.167,51.637a2.294,2.294,0,0,0,.031-.531c0-.4,0-.9,0-1.519,0-1.318,0-3.225.067-5.58.113-4.707.519-9.78,1.3-16.927C1.974,20.359,2.97,12.538,4.021,7.453c.225-1.157.452-2.2.666-3.108s.378-1.7.545-2.338c.144-.6.261-1.088.355-1.476A2.307,2.307,0,0,0,5.68.006,2.181,2.181,0,0,0,5.5.5c-.116.382-.261.864-.441,1.455-.2.631-.4,1.414-.625,2.323s-.489,1.946-.736,3.1A172.013,172.013,0,0,0,.763,25.6C-.022,32.758-.375,39.278-.406,44c-.028,2.361.022,4.272.082,5.591.038.617.069,1.119.092,1.518a2.28,2.28,0,0,0,.064.527",
    transform: "translate(0.414 -0.006)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038",
    transform: "translate(119.927 158.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4990",
    "data-name": "Path 4990",
    d: "M-11.381,35.249a10.033,10.033,0,0,0-.011-1.587c-.058-1.019-.2-2.493-.486-4.3a56.615,56.615,0,0,0-1.4-6.262A51.371,51.371,0,0,0-15.9,15.69a39.488,39.488,0,0,0-7.69-11.975A19.7,19.7,0,0,0-25.4,2.033c-.278-.234-.523-.468-.773-.654l-.7-.484A10.169,10.169,0,0,0-28.2.042a47.48,47.48,0,0,1,4.378,3.906,41.607,41.607,0,0,1,7.5,11.931,58.628,58.628,0,0,1,2.634,7.342,63.633,63.633,0,0,1,1.487,6.2c.328,1.788.517,3.246.632,4.256a10.352,10.352,0,0,0,.194,1.572",
    transform: "translate(28.207 -0.04)",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039",
    transform: "translate(149.168 213.826) rotate(85.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4991",
    "data-name": "Path 4991",
    d: "M0,24.637H17.313L18.927,2.514,1.8,0Z",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4040",
    "data-name": "Group 4040",
    transform: "translate(122.453 208.814)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1730",
    "data-name": "Rectangle 1730",
    width: 29.492,
    height: 6.806,
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4041",
    "data-name": "Group 4041",
    transform: "translate(122.453 232.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4992",
    "data-name": "Path 4992",
    d: "M0-3.163v1.887H29V-3.163Z",
    transform: "translate(0 3.163)",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4042",
    "data-name": "Group 4042",
    transform: "matrix(-0.379, -0.926, 0.926, -0.379, 128.583, 245.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4993",
    "data-name": "Path 4993",
    d: "M8.944,0H12.53L2.473,24.585,0,21.861Z",
    fill: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4043",
    "data-name": "Group 4043",
    transform: "translate(124.97 218.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4994",
    "data-name": "Path 4994",
    d: "M-16.177-1.647a.734.734,0,0,1-.1.159l-.332.439L-17.9.6l-.057.073L-18.018.6l-3.175-4.391h.183L-24.135.636l-.1.139-.109-.131-3.707-4.41h.214l-.2.257L-31.355.643l-.11.138-.1-.144-3.128-4.424.183.009L-38.363.609l-.069.078L-38.484.6-39.69-1.426l-.31-.54a.87.87,0,0,1-.094-.192.843.843,0,0,1,.129.171l.342.519L-38.356.521l-.12-.01,3.79-4.441.1-.112.086.12,3.155,4.4-.212,0,3.306-4.161.2-.257.1-.132.109.129,3.7,4.42L-24.35.48l3.157-4.4.092-.129.09.129L-17.9.519h-.113L-16.671-1.1l.36-.417c.084-.093.128-.139.134-.135",
    transform: "translate(40.094 4.072)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4044",
    "data-name": "Group 4044",
    transform: "translate(124.78 215.644) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4995",
    "data-name": "Path 4995",
    d: "M.138,24.827C.062,24.827,0,19.269,0,12.414S.062,0,.138,0,.276,5.557.276,12.414.214,24.827.138,24.827",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4045",
    "data-name": "Group 4045",
    transform: "translate(123.746 234.436) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4996",
    "data-name": "Path 4996",
    d: "M.138,26.982c-.076,0-.138-6.04-.138-13.49S.061,0,.138,0,.276,6.039.276,13.491.214,26.982.138,26.982",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046",
    transform: "translate(14.002 238.216) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4997",
    "data-name": "Path 4997",
    d: "M.156,338.788C.07,338.788,0,262.942,0,169.4,0,75.83.07,0,.156,0S.311,75.83.311,169.4c0,93.54-.07,169.386-.156,169.386",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4084",
    "data-name": "Group 4084",
    transform: "translate(25.173 58.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5031",
    "data-name": "Path 5031",
    d: "M-2.275,14.873s.093.078.259.243.4.418.734.725a14.064,14.064,0,0,0,3.25,2.185,11.147,11.147,0,0,0,1.237.515l.681.237.73.184a14.218,14.218,0,0,0,1.574.288c.275.029.558.039.844.06a6.019,6.019,0,0,0,.876.015,13.254,13.254,0,0,0,7.5-2.455l.045-.032.053.01L22.147,18.1l-.132.23-3.666-4.2-.076-.087.069-.1A14.515,14.515,0,0,0,19.936,11.1,14.408,14.408,0,0,0,20.8,7.822,13.21,13.21,0,0,0,19.811.893a13.29,13.29,0,0,0-6.146-6.507A13.217,13.217,0,0,0,5.386-6.8,12.605,12.605,0,0,0,1.651-5.52,12.744,12.744,0,0,0-1.373-3.34,12.966,12.966,0,0,0-4.858,2.32a13.1,13.1,0,0,0-.49,5.5,13.262,13.262,0,0,0,1.166,4.019l.36.734c.12.225.257.424.371.614a7.793,7.793,0,0,0,.626.935l.416.555a1.313,1.313,0,0,1,.134.2,1.349,1.349,0,0,1-.159-.176l-.441-.537a7.216,7.216,0,0,1-.654-.924c-.119-.19-.261-.387-.386-.611l-.376-.734a13.167,13.167,0,0,1-.778-9.63A13.16,13.16,0,0,1-1.552-3.522,13.26,13.26,0,0,1,5.334-7.078,13.482,13.482,0,0,1,13.8-5.886,13.575,13.575,0,0,1,20.1.77a13.493,13.493,0,0,1,1,7.091,14.68,14.68,0,0,1-.886,3.351,14.762,14.762,0,0,1-1.637,2.913l-.007-.185,3.655,4.21.267.307-.4-.077L15.456,17.1l.1-.021a13.422,13.422,0,0,1-7.64,2.454,6.189,6.189,0,0,1-.889-.022c-.291-.024-.577-.037-.856-.069a14.3,14.3,0,0,1-1.593-.306l-.737-.194L3.154,18.7a10.907,10.907,0,0,1-1.245-.536A13.536,13.536,0,0,1-1.333,15.9c-.325-.318-.551-.585-.711-.755a2.986,2.986,0,0,1-.231-.269",
    transform: "translate(5.638 7.312)",
    fill: "#30c5cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4085",
    "data-name": "Group 4085",
    transform: "translate(34.373 67.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5032",
    "data-name": "Path 5032",
    d: "M-2.727-11.851l2.243-.743,2.243-.743-.478,2.314L.8-8.709-.416-9.8-5.668-3.9l-1.09-.97,5.251-5.9Z",
    transform: "translate(6.758 13.337)",
    fill: "#30c5cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4086",
    "data-name": "Group 4086",
    transform: "translate(71.631 58.631) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5033",
    "data-name": "Path 5033",
    d: "M29.315,58.631A29.315,29.315,0,1,1,58.631,29.315,29.315,29.315,0,0,1,29.315,58.631",
    fill: "#30c5cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4087",
    "data-name": "Group 4087",
    transform: "translate(76.547 4.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5034",
    "data-name": "Path 5034",
    d: "M-16.5-70.631A20.247,20.247,0,0,0-36.727-50.408,20.247,20.247,0,0,0-16.5-30.183,20.247,20.247,0,0,0,3.72-50.408,20.247,20.247,0,0,0-16.5-70.631m0,44.624a24.427,24.427,0,0,1-24.4-24.4,24.427,24.427,0,0,1,24.4-24.4,24.427,24.427,0,0,1,24.4,24.4,24.427,24.427,0,0,1-24.4,24.4",
    transform: "translate(40.903 74.807)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4088",
    "data-name": "Group 4088",
    transform: "translate(91.797 19.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5035",
    "data-name": "Path 5035",
    d: "M-6.078-18.952a4.816,4.816,0,0,0-4.81,4.81,4.815,4.815,0,0,0,4.81,4.81,4.815,4.815,0,0,0,4.81-4.81,4.816,4.816,0,0,0-4.81-4.81m0,13.8a9,9,0,0,1-8.986-8.986,9,9,0,0,1,8.986-8.986,9,9,0,0,1,8.986,8.986A9,9,0,0,1-6.078-5.156",
    transform: "translate(15.064 23.128)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4089",
    "data-name": "Group 4089",
    transform: "translate(64.669 28.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5036",
    "data-name": "Path 5036",
    d: "M-24.427-28.936H-35.786l1.98,3.5L-60.541-13.178l.9,1.5,26.824-12.111,1.838,3.481Z",
    transform: "translate(60.541 28.936)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4090",
    "data-name": "Group 4090",
    transform: "translate(48.413 42.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5037",
    "data-name": "Path 5037",
    d: "M-11-15.159l-.284-.276a5.431,5.431,0,0,0-5.308-1.325l-10.664,3.1,5.939,2.609L-23.7-4.7l10-3.568a5.43,5.43,0,0,0,3.6-5.385Z",
    transform: "translate(27.252 16.977)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4091",
    "data-name": "Group 4091",
    transform: "translate(241.456 5.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5038",
    "data-name": "Path 5038",
    d: "M-47.96,69.712h-67.96a2.945,2.945,0,0,1-2.944-2.945V2.945A2.945,2.945,0,0,1-115.92,0h67.96a2.945,2.945,0,0,1,2.945,2.945V66.767a2.945,2.945,0,0,1-2.945,2.945",
    transform: "translate(118.864)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4092",
    "data-name": "Group 4092",
    transform: "translate(241.3 5.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5039",
    "data-name": "Path 5039",
    d: "M-48.065,69.638a4.507,4.507,0,0,0,.716-.108,2.949,2.949,0,0,0,1.692-1.2,2.913,2.913,0,0,0,.489-1.457c.016-.575,0-1.213,0-1.9,0-1.375-.009-2.959-.014-4.743-.012-7.143-.029-17.467-.05-30.225-.006-6.38-.012-13.369-.018-20.871V3.412a4.252,4.252,0,0,0-.136-1.4A2.829,2.829,0,0,0-46.13.837a2.766,2.766,0,0,0-1.221-.68A5.575,5.575,0,0,0-48.8.062L-61.128.069l-54.89.012a2.8,2.8,0,0,0-2.638,1.869,5.021,5.021,0,0,0-.159,1.742V26.663c0,9.182-.006,18.039-.009,26.476q0,6.327-.007,12.329c.006.494-.013,1.01.013,1.481a2.861,2.861,0,0,0,.47,1.318,2.836,2.836,0,0,0,2.386,1.235h5.722l20.873.019,30.222.049,8.217.029,2.137.016c.482,0,.728.016.728.016s-.246.011-.728.016l-2.137.016-8.217.029-30.222.05-20.873.019h-5.722a3.11,3.11,0,0,1-2.609-1.35,3.128,3.128,0,0,1-.517-1.444c-.029-.52-.009-1-.016-1.506q0-6-.006-12.329c0-8.438-.006-17.294-.009-26.476V2.782a3,3,0,0,1,.172-.935A3.111,3.111,0,0,1-116.016-.23l54.89.012L-48.8-.211h.748a3.156,3.156,0,0,1,.77.1,3.043,3.043,0,0,1,1.339.747,3.1,3.1,0,0,1,.809,1.288,4.51,4.51,0,0,1,.147,1.486q0,2.907,0,5.722C-44.994,16.632-45,23.623-45,30c-.021,12.758-.038,23.082-.05,30.225-.005,1.784-.01,3.368-.014,4.743-.007.688,0,1.318-.017,1.9a2.969,2.969,0,0,1-.514,1.488,2.956,2.956,0,0,1-1.736,1.194,2.39,2.39,0,0,1-.724.077",
    transform: "translate(119.125 0.23)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4093",
    "data-name": "Group 4093",
    transform: "translate(258.324 67.423) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1731",
    "data-name": "Rectangle 1731",
    width: 3.982,
    height: 34.206,
    fill: "#fbc343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4094",
    "data-name": "Group 4094",
    transform: "translate(276.418 67.423) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1732",
    "data-name": "Rectangle 1732",
    width: 3.982,
    height: 36.982,
    fill: "#fbc343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4095",
    "data-name": "Group 4095",
    transform: "translate(295.162 67.423) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1733",
    "data-name": "Rectangle 1733",
    width: 3.981,
    height: 41.678,
    fill: "#fbc343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4096",
    "data-name": "Group 4096",
    transform: "translate(286.356 67.423) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1734",
    "data-name": "Rectangle 1734",
    width: 3.982,
    height: 16.655,
    fill: "#fc8354"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4097",
    "data-name": "Group 4097",
    transform: "translate(262.963 67.423) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1735",
    "data-name": "Rectangle 1735",
    width: 3.982,
    height: 37.87,
    fill: "#30c5cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4098",
    "data-name": "Group 4098",
    transform: "translate(281.38 67.423) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1736",
    "data-name": "Rectangle 1736",
    width: 3.981,
    height: 45.805,
    fill: "#30c5cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4099",
    "data-name": "Group 4099",
    transform: "translate(305.426 67.423) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1737",
    "data-name": "Rectangle 1737",
    width: 3.982,
    height: 45.805,
    fill: "#fc8354"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4100",
    "data-name": "Group 4100",
    transform: "translate(300.48 67.423) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1738",
    "data-name": "Rectangle 1738",
    width: 3.982,
    height: 54.851,
    fill: "#30c5cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4101",
    "data-name": "Group 4101",
    transform: "translate(267.835 67.423) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1739",
    "data-name": "Rectangle 1739",
    width: 3.982,
    height: 24.035,
    fill: "#fc8354"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4102",
    "data-name": "Group 4102",
    transform: "translate(247.671 69.654) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5040",
    "data-name": "Path 5040",
    d: "M.156,63.452C.07,63.452,0,49.246,0,31.727S.07,0,.156,0,.311,14.2.311,31.727.242,63.452.156,63.452",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4103",
    "data-name": "Group 4103",
    transform: "translate(248.255 62.25) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    "data-name": "Rectangle 1740",
    width: 2.429,
    height: 0.911,
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4104",
    "data-name": "Group 4104",
    transform: "translate(248.255 50.077) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    "data-name": "Rectangle 1741",
    width: 2.429,
    height: 0.911,
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4105",
    "data-name": "Group 4105",
    transform: "translate(248.255 27.168) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742",
    "data-name": "Rectangle 1742",
    width: 2.429,
    height: 0.911,
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4106",
    "data-name": "Group 4106",
    transform: "translate(248.255 15.656) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1743",
    "data-name": "Rectangle 1743",
    width: 2.429,
    height: 0.911,
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4107",
    "data-name": "Group 4107",
    transform: "translate(248.379 38.623) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1744",
    "data-name": "Rectangle 1744",
    width: 2.43,
    height: 0.911,
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4108",
    "data-name": "Group 4108",
    transform: "translate(252.099 137.726) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1745",
    "data-name": "Rectangle 1745",
    width: 137.405,
    height: 106.939,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4109",
    "data-name": "Group 4109",
    transform: "translate(114.537 30.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5041",
    "data-name": "Path 5041",
    d: "M-93.047,106.861c0-1.067-.051-42.4-.128-106.939l.128.128L-230.441.077h-.011l.155-.155c-.006,38.547-.011,75.006-.016,106.939l-.14-.139,137.4.139-137.4.14h-.14v-.14c0-31.933-.01-68.392-.016-106.939V-.234h.167l137.394.027h.129v.128c-.078,64.535-.127,105.873-.129,106.939",
    transform: "translate(230.608 0.234)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4110",
    "data-name": "Group 4110",
    transform: "translate(155.143 76.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5042",
    "data-name": "Path 5042",
    d: "M-.1,48.2c-.086,0-.156-10.791-.156-24.1S-.191,0-.1,0,.05,10.789.05,24.1-.019,48.2-.1,48.2",
    transform: "translate(0.261)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4111",
    "data-name": "Group 4111",
    transform: "translate(210.508 76.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5043",
    "data-name": "Path 5043",
    d: "M-.1,48.2c-.086,0-.155-10.791-.155-24.1S-.191,0-.1,0,.051,10.789.051,24.1-.018,48.2-.1,48.2",
    transform: "translate(0.26)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4112",
    "data-name": "Group 4112",
    transform: "translate(174.045 63.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5044",
    "data-name": "Path 5044",
    d: "M-.1,61.619c-.086,0-.156-13.8-.156-30.808S-.191,0-.1,0,.05,13.792.05,30.811-.019,61.619-.1,61.619",
    transform: "translate(0.261)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4113",
    "data-name": "Group 4113",
    transform: "translate(135.732 63.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5045",
    "data-name": "Path 5045",
    d: "M-.1,61.619c-.086,0-.155-13.8-.155-30.808S-.191,0-.1,0,.05,13.792.05,30.811-.019,61.619-.1,61.619",
    transform: "translate(0.26)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4114",
    "data-name": "Group 4114",
    transform: "translate(232.238 63.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5046",
    "data-name": "Path 5046",
    d: "M-.1,61.619c-.086,0-.156-13.8-.156-30.808S-.191,0-.1,0,.05,13.792.05,30.811-.02,61.619-.106,61.619",
    transform: "translate(0.261)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4115",
    "data-name": "Group 4115",
    transform: "translate(190.619 53.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5047",
    "data-name": "Path 5047",
    d: "M-.1,71.147c-.086,0-.155-15.928-.155-35.572S-.191,0-.1,0,.051,15.924.051,35.575-.018,71.147-.1,71.147",
    transform: "translate(0.26)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4116",
    "data-name": "Group 4116",
    transform: "translate(154.847 76.878) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5048",
    "data-name": "Path 5048",
    d: "M.452.9A.452.452,0,1,1,.9.452.452.452,0,0,1,.452.9",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4117",
    "data-name": "Group 4117",
    transform: "translate(173.748 63.458) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5049",
    "data-name": "Path 5049",
    d: "M.452.9A.452.452,0,1,1,.9.452.452.452,0,0,1,.452.9",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4118",
    "data-name": "Group 4118",
    transform: "translate(172.591 61.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5050",
    "data-name": "Path 5050",
    d: "M-1.088-4.994A1.461,1.461,0,0,0-2.547-3.535a1.461,1.461,0,0,0,1.459,1.46,1.462,1.462,0,0,0,1.46-1.46,1.461,1.461,0,0,0-1.46-1.459m0,3.068A1.61,1.61,0,0,1-2.7-3.535,1.61,1.61,0,0,1-1.088-5.143,1.61,1.61,0,0,1,.521-3.535,1.611,1.611,0,0,1-1.088-1.926",
    transform: "translate(2.696 5.143)",
    fill: "#ff4f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4119",
    "data-name": "Group 4119",
    transform: "translate(190.322 53.93) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5051",
    "data-name": "Path 5051",
    d: "M.452.9A.452.452,0,1,1,.9.452.452.452,0,0,1,.452.9",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4120",
    "data-name": "Group 4120",
    transform: "translate(210.211 77.33) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5052",
    "data-name": "Path 5052",
    d: "M.453.9A.452.452,0,1,1,.9.452.452.452,0,0,1,.453.9",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4121",
    "data-name": "Group 4121",
    transform: "translate(231.952 63.458) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5053",
    "data-name": "Path 5053",
    d: "M.453.9A.452.452,0,1,1,.9.452.452.452,0,0,1,.453.9",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4122",
    "data-name": "Group 4122",
    transform: "translate(135.435 63.91) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5054",
    "data-name": "Path 5054",
    d: "M.452.9A.452.452,0,1,1,.9.452.452.452,0,0,1,.452.9",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4123",
    "data-name": "Group 4123",
    transform: "translate(127.442 73.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5055",
    "data-name": "Path 5055",
    d: "M-73.885-15.046c.011.052-.5.122-1.371.493a9.959,9.959,0,0,0-3.264,2.511c-1.223,1.337-2.449,3.2-4,5.3a25.577,25.577,0,0,1-2.731,3.187,15.157,15.157,0,0,1-1.781,1.479A12.451,12.451,0,0,1-89.18-.9a12.134,12.134,0,0,1-5.157.878,13.885,13.885,0,0,1-2.775-.344,7.294,7.294,0,0,1-2.7-1.186,8.746,8.746,0,0,1-2.11-2.194c-.579-.837-1.1-1.719-1.6-2.613-1-1.8-2.028-3.6-3.2-5.415-1.159-1.843-2.229-3.781-3.42-5.684a27.982,27.982,0,0,0-4.158-5.36,11.989,11.989,0,0,0-2.78-1.974,10.589,10.589,0,0,0-1.586-.648c-.277-.072-.561-.122-.842-.186l-.422-.091c-.141-.028-.288-.024-.431-.038A11.972,11.972,0,0,0-127.19-24.3a17.7,17.7,0,0,0-5.217,4.871,53.491,53.491,0,0,0-3.756,6.03c-2.273,4.115-4.777,8.036-8.092,10.975a13.867,13.867,0,0,1-5.63,3.135A10.759,10.759,0,0,1-153,1.052,11.768,11.768,0,0,1-155.97.5a20.038,20.038,0,0,1-5-2.621c-1.479-1.022-2.829-2.079-4.146-3.03a22.144,22.144,0,0,0-3.919-2.387,12.957,12.957,0,0,0-3.9-1.117,9.6,9.6,0,0,0-3.5.214,5.817,5.817,0,0,0-.758.241,4.791,4.791,0,0,0-.709.276,9.1,9.1,0,0,0-1.241.681,13.31,13.31,0,0,0-1.874,1.483c-.462.519-.894.927-1.181,1.309a8.766,8.766,0,0,1-.926,1.136,8.587,8.587,0,0,1,.777-1.251c.266-.405.682-.84,1.133-1.389a12.913,12.913,0,0,1,1.872-1.592,9.327,9.327,0,0,1,1.27-.744,5.069,5.069,0,0,1,.733-.308,6.19,6.19,0,0,1,.788-.272,9.976,9.976,0,0,1,3.669-.3,13.384,13.384,0,0,1,4.08,1.094,22.414,22.414,0,0,1,4.061,2.392c1.342.944,2.7,1.982,4.167,2.971a19.424,19.424,0,0,0,4.832,2.48,11.059,11.059,0,0,0,2.771.5,9.993,9.993,0,0,0,2.872-.337,13.084,13.084,0,0,0,5.271-2.987c3.162-2.831,5.618-6.682,7.861-10.776a53.961,53.961,0,0,1,3.809-6.137,18.558,18.558,0,0,1,5.5-5.128,12.868,12.868,0,0,1,7.383-1.563c.157.016.317.014.472.044l.465.1c.31.069.621.127.925.207a11.452,11.452,0,0,1,1.739.713,12.9,12.9,0,0,1,2.992,2.131,28.666,28.666,0,0,1,4.287,5.554c1.2,1.935,2.261,3.879,3.392,5.7,1.157,1.821,2.212,3.683,3.184,5.471a13.413,13.413,0,0,0,3.442,4.579,6.551,6.551,0,0,0,2.433,1.089,13.2,13.2,0,0,0,2.625.35,11.49,11.49,0,0,0,4.878-.769A11.828,11.828,0,0,0-87.383-2.6a14.767,14.767,0,0,0,1.728-1.392A25.657,25.657,0,0,0-82.932-7.06a64.816,64.816,0,0,1,4.145-5.228,9.558,9.558,0,0,1,3.459-2.438,5.682,5.682,0,0,1,1.068-.283,1.147,1.147,0,0,1,.374-.037",
    transform: "translate(183.118 26.722)",
    fill: "#30c5cc",
    stroke: "#30c5cc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4124",
    "data-name": "Group 4124",
    transform: "translate(157.679 46.074) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1746",
    "data-name": "Rectangle 1746",
    width: 22.243,
    height: 1.238,
    fill: "#30c5cc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4125",
    "data-name": "Group 4125",
    transform: "translate(146.427 48.971) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1747",
    "data-name": "Rectangle 1747",
    width: 10.992,
    height: 1.238,
    fill: "#fbc343"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4126",
    "data-name": "Group 4126",
    transform: "translate(252.099 36.26) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1748",
    "data-name": "Rectangle 1748",
    width: 137.405,
    height: 8.59,
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4127",
    "data-name": "Group 4127",
    transform: "translate(99.026 75.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5056",
    "data-name": "Path 5056",
    d: "M-20.338-39.156a1.612,1.612,0,0,1-.025,1.529l-12.484,22.3a7.891,7.891,0,0,1-10.577,2.672L-50.4-16.616-45.568-25l5.185,3.126,12.541-16.575a15.473,15.473,0,0,0,.186-2.778,4.179,4.179,0,0,0-.258-1.4,6.391,6.391,0,0,0-.774-1.6.551.551,0,0,1-.091-.633.551.551,0,0,1,.568-.293,4.525,4.525,0,0,1,1.925,2.96c.453,1.7,1.589-.826,2.02-1.739s1.9-3.678,2.281-3.768c.565-.132.812.45.36,1.352s-1.614,3.7-1.12,3.908c0,0,.874.2,1.092.744Z",
    transform: "translate(50.405 47.721)",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4128",
    "data-name": "Group 4128",
    transform: "translate(125.383 81.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5057",
    "data-name": "Path 5057",
    d: "M-1.467-5.437a3.81,3.81,0,0,1-.255,1.053l-.357,1.112-.221.653a.948.948,0,0,1-.2.377.458.458,0,0,1-.52.069A1.711,1.711,0,0,1-3.366-2.4a.7.7,0,0,1-.257-.375,1.393,1.393,0,0,1,.157-.748l.428-1.086a3.75,3.75,0,0,1,.469-.973,3.762,3.762,0,0,1-.263,1.048L-3.2-3.427a1.3,1.3,0,0,0-.131.58c.019.128.261.3.434.391.1.039.138.033.179-.005a.761.761,0,0,0,.131-.265c.081-.22.159-.435.237-.646l.419-1.089a3.759,3.759,0,0,1,.46-.974",
    transform: "translate(3.635 5.584)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4129",
    "data-name": "Group 4129",
    transform: "translate(126.068 82.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5058",
    "data-name": "Path 5058",
    d: "M-1.311-3.712a3.078,3.078,0,0,1-.217.956c-.1.332-.21.668-.318,1.012l-.1.292a.675.675,0,0,1-.224.335.467.467,0,0,1-.463.02,1.616,1.616,0,0,1-.318-.2.8.8,0,0,1-.263-.324.683.683,0,0,1-.01-.418c.07-.236.149-.41.219-.6l.391-.982A3.1,3.1,0,0,1-2.179-4.5a3.135,3.135,0,0,1-.228.953l-.329,1.005c-.06.184-.144.4-.192.577a.353.353,0,0,0,.17.425c.17.141.36.239.417.177.085-.048.156-.3.224-.477l.379-.984a3.141,3.141,0,0,1,.424-.883",
    transform: "translate(3.249 4.506)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4130",
    "data-name": "Group 4130",
    transform: "translate(126.898 83.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5059",
    "data-name": "Path 5059",
    d: "M-1.311-3.712a3.121,3.121,0,0,1-.217.956c-.1.332-.21.668-.318,1.012l-.1.292a.675.675,0,0,1-.223.335.468.468,0,0,1-.464.02,1.611,1.611,0,0,1-.317-.2.786.786,0,0,1-.263-.324.679.679,0,0,1-.01-.418c.069-.236.149-.41.218-.6l.391-.982A3.132,3.132,0,0,1-2.179-4.5a3.1,3.1,0,0,1-.228.953l-.329,1.005c-.059.184-.143.4-.192.577a.354.354,0,0,0,.17.425c.171.141.361.239.417.177.086-.048.156-.3.225-.477l.378-.984a3.131,3.131,0,0,1,.425-.883",
    transform: "translate(3.249 4.506)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4131",
    "data-name": "Group 4131",
    transform: "translate(123.971 82.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5060",
    "data-name": "Path 5060",
    d: "M-.747,3.457a8.3,8.3,0,0,0-.221-1.82A8.332,8.332,0,0,0-1.847.029c.024-.03.222.071.472.325a3.057,3.057,0,0,1,.7,1.189,3.065,3.065,0,0,1,.12,1.376c-.057.352-.159.549-.2.539",
    transform: "translate(1.851 -0.023)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4132",
    "data-name": "Group 4132",
    transform: "translate(64.533 53.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5061",
    "data-name": "Path 5061",
    d: "M-14.208-22.194a5.273,5.273,0,0,0-5.872-1.064,15.954,15.954,0,0,1-2.6,1.339,9.339,9.339,0,0,1-3.485-.206c-1.163-.144-2.537.027-3.175,1.01-.411.633-.434,1.5-.969,2.029-.738.736-1.979.443-2.979.735a2.78,2.78,0,0,0-1.884,2.208,3.3,3.3,0,0,0,.952,2.793,5.11,5.11,0,0,1,1.19,1.277,3.869,3.869,0,0,1-.047,2.257c-.125.756-.027,1.7.66,2.035a1.061,1.061,0,0,0,1.133-.144,1.06,1.06,0,0,0,.311-1.1l14.453-4.63c2.18,0,2.867-1.961,3.212-2.641a5.272,5.272,0,0,0-.9-5.9",
    transform: "translate(35.212 23.724)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4133",
    "data-name": "Group 4133",
    transform: "translate(68.316 59.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5062",
    "data-name": "Path 5062",
    d: "M0-48.414l.031,1.563L.345-23.459A5.018,5.018,0,0,0,2-19.956a5.018,5.018,0,0,0,3.655,1.283,5.3,5.3,0,0,0,5.33-5.079c.009-2.88.071-5.911.071-5.911s3.71-.617,4.479-5.457a51.7,51.7,0,0,0,.057-9.58,5.111,5.111,0,0,0-1.8-3.587,5.111,5.111,0,0,0-3.836-1.179Z",
    transform: "translate(0 49.495)",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4134",
    "data-name": "Group 4134",
    transform: "translate(81.708 67.266) rotate(-93.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5063",
    "data-name": "Path 5063",
    d: "M.593,1.241A.621.621,0,0,1,0,.609.594.594,0,0,1,.593,0a.622.622,0,0,1,.594.632.593.593,0,0,1-.594.609",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4135",
    "data-name": "Group 4135",
    transform: "translate(80.597 65.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5064",
    "data-name": "Path 5064",
    d: "M-1.66.52C-1.737.6-2.207.252-2.875.254S-4.032.59-4.105.508C-4.14.472-4.062.326-3.848.17a1.7,1.7,0,0,1,.985-.3A1.639,1.639,0,0,1-1.9.18c.2.157.274.3.237.34",
    transform: "translate(4.114 0.133)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4136",
    "data-name": "Group 4136",
    transform: "translate(75.022 67.266) rotate(-93.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5065",
    "data-name": "Path 5065",
    d: "M.593,1.241A.621.621,0,0,1,0,.609.594.594,0,0,1,.593,0a.622.622,0,0,1,.594.632.593.593,0,0,1-.594.609",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4137",
    "data-name": "Group 4137",
    transform: "translate(74.03 65.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5066",
    "data-name": "Path 5066",
    d: "M-1.66.52C-1.737.6-2.207.253-2.875.255s-1.158.336-1.23.254c-.035-.036.042-.182.257-.338a1.7,1.7,0,0,1,.984-.3A1.639,1.639,0,0,1-1.9.18c.2.157.274.3.237.34",
    transform: "translate(4.114 0.133)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4138",
    "data-name": "Group 4138",
    transform: "translate(78.596 65.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5067",
    "data-name": "Path 5067",
    d: "M-.212,5.549a4.408,4.408,0,0,1,1.085-.2c.17-.018.332-.052.361-.168a.875.875,0,0,0-.114-.506q-.241-.618-.5-1.3A22.2,22.2,0,0,1-.517-.017a22.369,22.369,0,0,1,1.4,3.3l.483,1.306a.989.989,0,0,1,.088.67.426.426,0,0,1-.28.249,1.139,1.139,0,0,1-.289.04,4.347,4.347,0,0,1-1.1,0",
    transform: "translate(0.524 0.018)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4139",
    "data-name": "Group 4139",
    transform: "translate(72.887 77.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5068",
    "data-name": "Path 5068",
    d: "M-4.385-.946a12.315,12.315,0,0,1-6.483-1.729S-9.3.65-4.45.2Z",
    transform: "translate(10.868 2.675)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4140",
    "data-name": "Group 4140",
    transform: "translate(76.834 71.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5069",
    "data-name": "Path 5069",
    d: "M-.073-3.226c.109-.006.11.719.731,1.234s1.393.435,1.4.536c.01.045-.172.141-.5.15A1.806,1.806,0,0,1,.39-1.713,1.57,1.57,0,0,1-.176-2.748c-.028-.3.053-.483.1-.478",
    transform: "translate(0.182 3.226)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4141",
    "data-name": "Group 4141",
    transform: "translate(73.608 62.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5070",
    "data-name": "Path 5070",
    d: "M-2.062-.276c-.066.182-.733.1-1.516.19S-5,.222-5.1.059c-.047-.078.064-.249.319-.425A2.542,2.542,0,0,1-3.653-.76a2.537,2.537,0,0,1,1.186.14c.288.116.432.258.4.345",
    transform: "translate(5.11 0.777)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4142",
    "data-name": "Group 4142",
    transform: "translate(80.53 63.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5071",
    "data-name": "Path 5071",
    d: "M-1.539.456C-1.656.607-2.116.45-2.669.443-3.222.416-3.691.545-3.8.386c-.047-.077.026-.229.231-.373A1.568,1.568,0,0,1-2.65-.236a1.568,1.568,0,0,1,.9.3c.2.156.259.312.208.386",
    transform: "translate(3.813 0.236)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4143",
    "data-name": "Group 4143",
    transform: "translate(67.509 58.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5072",
    "data-name": "Path 5072",
    d: "M-11.2-7.121a6.883,6.883,0,0,1-5.791-.233c-2.178-1-4.693-1.446-5.231-1s-.583,2.662-2.687,3.373c0,0,.279,4.211-1.407,4.114s-1.43-8.548-1.43-8.548l4.637-.248,4.46-.99,4.246.462,3.3.792Z",
    transform: "translate(27.76 10.651)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4144",
    "data-name": "Group 4144",
    transform: "translate(68.979 58.435) rotate(109.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5073",
    "data-name": "Path 5073",
    d: "M.325,1.552C.273,1.6,0,1.273,0,.779S.273-.04.325,0,.249.365.254.778s.134.737.072.774",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4145",
    "data-name": "Group 4145",
    transform: "matrix(-0.981, 0.192, -0.192, -0.981, 69.241, 58.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5074",
    "data-name": "Path 5074",
    d: "M.025,2.144c-.076-.021.045-.5.069-1.078S-.043.033.025,0A1.311,1.311,0,0,1,.347,1.074a1.651,1.651,0,0,1-.323,1.07",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4146",
    "data-name": "Group 4146",
    transform: "translate(66.223 66.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5075",
    "data-name": "Path 5075",
    d: "M-1.913-6.37c-.069-.03-2.8-.958-2.827,1.87a2.122,2.122,0,0,0,.814,1.86,2.122,2.122,0,0,0,2,.325c0-.081.01-4.055.01-4.055",
    transform: "translate(4.74 6.541)",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4147",
    "data-name": "Group 4147",
    transform: "translate(66.939 66.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5076",
    "data-name": "Path 5076",
    d: "M-.845,1.816c-.013-.01-.05.034-.133.071a.489.489,0,0,1-.368,0A1.216,1.216,0,0,1-1.9.793a1.63,1.63,0,0,1,.145-.7.57.57,0,0,1,.374-.374.25.25,0,0,1,.289.138c.037.079.018.135.033.14S-1-.051-1.018-.168a.309.309,0,0,0-.109-.178A.367.367,0,0,0-1.4-.42a.69.69,0,0,0-.518.432A1.663,1.663,0,0,0-2.1.8a1.277,1.277,0,0,0,.71,1.223.525.525,0,0,0,.45-.07c.088-.069.1-.131.094-.137",
    transform: "translate(2.095 0.423)",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4148",
    "data-name": "Group 4148",
    transform: "translate(48.175 81.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5077",
    "data-name": "Path 5077",
    d: "M-21.618-80.4c2.073.117,5.558.4,12.437,4.42,1.5.878,16.934,11.24,16.934,11.24L.919-56l-12.581-7.087,1.695,15.065,1.886,17.913L-38.569-30.5l-.761-17.991-.258-12.236L-41.523-44.39l-12.056-1.146,3.326-21.523a14.34,14.34,0,0,1,3.176-7.161,17.627,17.627,0,0,1,7.746-4.99,25.419,25.419,0,0,1,5.682-1.038l-.1-3.6s5.422.507,6.866,3.99c0,0,1.8-4.118,5.282-4.458Z",
    transform: "translate(53.579 84.316)",
    fill: "#96c4ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4160",
    "data-name": "Group 4160",
    transform: "translate(61.539 86.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5089",
    "data-name": "Path 5089",
    d: "M0-29.633c0-.01.069.011.191.06A3.75,3.75,0,0,1,.7-29.32a5.586,5.586,0,0,1,1.563,1.408,7.408,7.408,0,0,1,1.314,2.83,10.384,10.384,0,0,1,.089,3.817,21.406,21.406,0,0,1-.938,3.69c-.373,1.106-.743,2.087-1.032,2.916s-.506,1.506-.645,1.977a4.412,4.412,0,0,1-.235.729,3.211,3.211,0,0,1,.122-.758c.1-.483.291-1.174.557-2.015a43.954,43.954,0,0,0,1.874-6.583,10.457,10.457,0,0,0-.062-3.712A7.49,7.49,0,0,0,2.1-27.785,6.781,6.781,0,0,0,0-29.633",
    transform: "translate(0.002 29.635)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4161",
    "data-name": "Group 4161",
    transform: "translate(88.194 87.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5090",
    "data-name": "Path 5090",
    d: "M-1.538,18.534a3.47,3.47,0,0,1-.125-.725c-.067-.529-.15-1.194-.25-1.985-.211-1.739-.489-4.025-.8-6.551s-.585-4.812-.8-6.552c-.1-.791-.176-1.456-.24-1.985A3.524,3.524,0,0,1-3.8,0a3.483,3.483,0,0,1,.176.715c.089.465.205,1.139.335,1.974.259,1.671.574,3.984.885,6.545s.557,4.881.709,6.564c.076.842.127,1.524.154,2a3.437,3.437,0,0,1,.008.736",
    transform: "translate(3.812 -0.003)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4162",
    "data-name": "Group 4162",
    transform: "translate(68.058 83.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5091",
    "data-name": "Path 5091",
    d: "M-3.913-4.007a1.437,1.437,0,0,0-1.017.133,1.722,1.722,0,0,0-.719.836,4.17,4.17,0,0,0-.227.647l-.094.359a.907.907,0,0,1-.192.416.416.416,0,0,1-.268.129.573.573,0,0,1-.254-.048c-.134-.058-.233-.111-.348-.165l-.638-.314L-8.742-2.56A4.094,4.094,0,0,1-9.7-3.132a4.159,4.159,0,0,1,1.046.381l1.1.489.645.3.333.153c.107.04.146.035.193-.011a2.452,2.452,0,0,0,.221-.65A4.189,4.189,0,0,1-5.9-3.158a1.854,1.854,0,0,1,.873-.906,1.242,1.242,0,0,1,.843-.1c.2.058.279.141.27.154",
    transform: "translate(9.699 4.197)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4163",
    "data-name": "Group 4163",
    transform: "translate(75.886 83.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5092",
    "data-name": "Path 5092",
    d: "M-2.927-2.39A16.573,16.573,0,0,1-5.279-.437l-.2.148-.042-.243L-5.57-.839a3.586,3.586,0,0,0-.882-2.075,3.207,3.207,0,0,0-.8-.507c-.01-.032.434-.067.944.348a2.457,2.457,0,0,1,.669.892,5.3,5.3,0,0,1,.367,1.29l.053.311-.237-.1A16.606,16.606,0,0,1-2.927-2.39",
    transform: "translate(7.255 3.438)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4164",
    "data-name": "Group 4164",
    transform: "translate(49.734 117.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5093",
    "data-name": "Path 5093",
    d: "M-6.761,2.5A8.866,8.866,0,0,1-8.22,2.09c-.891-.274-2.126-.638-3.5-.985S-14.363.5-15.278.317a8.9,8.9,0,0,1-1.478-.332,6.606,6.606,0,0,1,1.513.122A34.471,34.471,0,0,1-11.65.813a34.58,34.58,0,0,1,3.5,1.076A6.585,6.585,0,0,1-6.761,2.5",
    transform: "translate(16.756 0.03)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4165",
    "data-name": "Group 4165",
    transform: "translate(50.712 116.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5094",
    "data-name": "Path 5094",
    d: "M0-6.383a6.51,6.51,0,0,1,1.442.3c.879.229,2.082.586,3.391,1.043.654.228,1.272.461,1.83.682a9.1,9.1,0,0,1,1.46.676c.82.492,1,1.123.962,1.118A3.289,3.289,0,0,0,8.016-3.5a11.2,11.2,0,0,0-1.452-.6L4.733-4.76c-1.3-.456-2.49-.842-3.351-1.123A7.945,7.945,0,0,1,0-6.383",
    transform: "translate(0 6.391)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4166",
    "data-name": "Group 4166",
    transform: "translate(103.623 99.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5095",
    "data-name": "Path 5095",
    d: "M0,7.051A4.689,4.689,0,0,1,.509,5.893,26.936,26.936,0,0,1,3.957.868a4.661,4.661,0,0,1,.9-.894C4.92.033,3.673,1.5,2.338,3.453S.076,7.092,0,7.051",
    transform: "translate(0.007 0.027)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4167",
    "data-name": "Group 4167",
    transform: "translate(102.723 100.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5096",
    "data-name": "Path 5096",
    d: "M0,5.479A3.573,3.573,0,0,1,.527,4.435,12.669,12.669,0,0,1,4.519.486,3.594,3.594,0,0,1,5.568-.033,33.911,33.911,0,0,0,2.512,2.45,33.975,33.975,0,0,0,0,5.479",
    transform: "translate(0.006 0.036)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4168",
    "data-name": "Group 4168",
    transform: "translate(75.138 88.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5097",
    "data-name": "Path 5097",
    d: "M-4.164,47.294a2.884,2.884,0,0,1-.081-.479q-.064-.515-.173-1.379c-.144-1.231-.345-2.957-.594-5.077-.5-4.287-1.182-10.209-2-16.744S-8.614,11.171-9.255,6.9c-.327-2.133-.586-3.859-.79-5.048L-10.262.484A2.772,2.772,0,0,1-10.317,0,2.844,2.844,0,0,1-10.2.472l.275,1.363c.242,1.183.532,2.906.888,5.035.7,4.262,1.528,10.169,2.34,16.707s1.465,12.464,1.9,16.758c.207,2.125.376,3.855.5,5.088.048.579.086,1.04.115,1.386a2.8,2.8,0,0,1,.018.485",
    transform: "translate(10.32 -0.001)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169",
    transform: "translate(77.357 98.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5098",
    "data-name": "Path 5098",
    d: "M-.018-.422C-.055-.412-.1-.672.191-.9A.6.6,0,0,1,.812-.952a.656.656,0,0,1,.358.686.63.63,0,0,1-.6.494A.519.519,0,0,1,.057-.145.486.486,0,0,1,.1-.551c.055-.082.11-.1.123-.085.034.026-.078.191.038.411a.288.288,0,0,0,.293.168.361.361,0,0,0,.31-.265A.39.39,0,0,0,.676-.7.384.384,0,0,0,.305-.71C.078-.6.026-.41-.018-.422",
    transform: "translate(0.045 1.015)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4170",
    "data-name": "Group 4170",
    transform: "translate(79.16 108.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5099",
    "data-name": "Path 5099",
    d: "M-.018-.423C-.055-.412-.1-.673.191-.9A.6.6,0,0,1,.812-.953a.657.657,0,0,1,.358.686.631.631,0,0,1-.6.5A.52.52,0,0,1,.057-.146.487.487,0,0,1,.1-.551c.056-.082.111-.1.124-.086.033.026-.078.191.038.411a.288.288,0,0,0,.293.168.36.36,0,0,0,.31-.265A.391.391,0,0,0,.676-.7.384.384,0,0,0,.305-.71C.078-.6.026-.41-.018-.423",
    transform: "translate(0.045 1.016)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4171",
    "data-name": "Group 4171",
    transform: "translate(64.548 229.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5100",
    "data-name": "Path 5100",
    d: "M-6.815.272l-.12-5.314-9.955.163L-16.8,2.9l.617.029C-13.434,3.037-2.2,3.283-.369,2.7,1.674,2.038-6.815.272-6.815.272",
    transform: "translate(16.89 5.042)",
    fill: "#d3dffd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4173",
    "data-name": "Group 4173",
    transform: "translate(64.643 236.269)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4172",
    "data-name": "Group 4172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5101",
    "data-name": "Path 5101",
    d: "M-9.558-3.31s2.978.807,2.616,1.3-11.727.673-16.747.314l.013-.223,13.259-.1s.28-1.262.86-1.3",
    transform: "translate(23.689 3.31)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4174",
    "data-name": "Group 4174",
    transform: "translate(64.498 237.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5102",
    "data-name": "Path 5102",
    d: "M0,.037A.9.9,0,0,0,.171.052L.663.074l1.81.05C4,.155,6.115.17,8.449.134S12.9.021,14.423-.056l1.808-.1L16.722-.2a.9.9,0,0,0,.171-.021.9.9,0,0,0-.172,0l-.492.015L14.42-.141c-1.528.055-3.639.119-5.972.154S4,.048,2.475.038L.665.027H.172A.889.889,0,0,0,0,.037",
    transform: "translate(0 0.221)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4175",
    "data-name": "Group 4175",
    transform: "translate(78.6 236.004) rotate(30.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5103",
    "data-name": "Path 5103",
    d: "M.284,1.827A4.091,4.091,0,0,1,.12.915,4.1,4.1,0,0,1,.284,0,1.337,1.337,0,0,0,0,.914a1.337,1.337,0,0,0,.284.913",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4176",
    "data-name": "Group 4176",
    transform: "matrix(0.853, 0.522, -0.522, 0.853, 75.414, 235.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5104",
    "data-name": "Path 5104",
    d: "M.06.981A1.068,1.068,0,0,0,.12.491,1.049,1.049,0,0,0,.06,0,1.044,1.044,0,0,0,0,.49,1.051,1.051,0,0,0,.06.981",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4177",
    "data-name": "Group 4177",
    transform: "matrix(0.68, 0.733, -0.733, 0.68, 74.712, 235.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5105",
    "data-name": "Path 5105",
    d: "M.06.836C.094.835.121.648.12.418S.094,0,.06,0,0,.187,0,.418.027.836.06.836",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4178",
    "data-name": "Group 4178",
    transform: "translate(74.656 234.867) rotate(89.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5106",
    "data-name": "Path 5106",
    d: "M.06,1.041A1.186,1.186,0,0,0,.121.52,1.186,1.186,0,0,0,.06,0,1.184,1.184,0,0,0,0,.52a1.168,1.168,0,0,0,.06.521",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4179",
    "data-name": "Group 4179",
    transform: "matrix(-0.06, 0.998, -0.998, -0.06, 74.611, 234.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5107",
    "data-name": "Path 5107",
    d: "M.014,1.182A1.01,1.01,0,0,0,.139.591,1.007,1.007,0,0,0,.014,0a3.3,3.3,0,0,0,0,.591,3.181,3.181,0,0,0,0,.591",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4180",
    "data-name": "Group 4180",
    transform: "translate(75.277 234.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5108",
    "data-name": "Path 5108",
    d: "M0,.931A1.87,1.87,0,0,0,.639.917,3.762,3.762,0,0,0,1.318.756,1.883,1.883,0,0,0,1.705.589a.348.348,0,0,0,.156-.2.253.253,0,0,0-.1-.254A1.172,1.172,0,0,0,.314.5a1.153,1.153,0,0,0-.2.43A.356.356,0,0,0,.1,1.1,1.8,1.8,0,0,1,.382.553,1.155,1.155,0,0,1,.922.189a1,1,0,0,1,.764.04c.1.073.065.193-.047.263a1.9,1.9,0,0,1-.357.159A4.4,4.4,0,0,1,.626.833C.243.906,0,.911,0,.931",
    transform: "translate(0 -0.016)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4181",
    "data-name": "Group 4181",
    transform: "translate(74.593 234.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5109",
    "data-name": "Path 5109",
    d: "M-.575,1.242A.63.63,0,0,0-.508.8,1.047,1.047,0,0,0-.69.332.641.641,0,0,0-1.228.014a.255.255,0,0,0-.192.3A.7.7,0,0,0-1.308.6,1.983,1.983,0,0,0-1,.98a.905.905,0,0,0,.37.252C-.618,1.216-.758,1.12-.938.92A2.191,2.191,0,0,1-1.212.54C-1.3.407-1.366.164-1.206.133S-.88.271-.78.4A1.057,1.057,0,0,1-.592.811a2.337,2.337,0,0,1,.017.431",
    transform: "translate(1.425 -0.013)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4182",
    "data-name": "Group 4182",
    transform: "translate(64.659 234.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5110",
    "data-name": "Path 5110",
    d: "M0-4.542c0,.022.285-.032.736.014a3.223,3.223,0,0,1,1.615.636,3.219,3.219,0,0,1,1.025,1.4c.159.424.178.711.2.707a.585.585,0,0,0,0-.2,2.6,2.6,0,0,0-.118-.535A3.073,3.073,0,0,0,2.424-3.987,3.073,3.073,0,0,0,.743-4.612,2.618,2.618,0,0,0,.2-4.59a.557.557,0,0,0-.2.048",
    transform: "translate(0 4.617)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4183",
    "data-name": "Group 4183",
    transform: "matrix(-1, 0.003, -0.003, -1, 65.698, 234.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5111",
    "data-name": "Path 5111",
    d: "M.06,4.091A17.392,17.392,0,0,0,.12,2.045,17.378,17.378,0,0,0,.06,0,17.549,17.549,0,0,0,0,2.046,17.534,17.534,0,0,0,.06,4.091",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4184",
    "data-name": "Group 4184",
    transform: "translate(72.397 236.725) rotate(89.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5112",
    "data-name": "Path 5112",
    d: "M.013,2.909A5.638,5.638,0,0,0,.144,1.454,5.626,5.626,0,0,0,.013,0c-.035,0,.011.653.01,1.455S-.021,2.906.013,2.909",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4185",
    "data-name": "Group 4185",
    transform: "matrix(-0.904, 0.427, -0.427, -0.904, 67.903, 237.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5113",
    "data-name": "Path 5113",
    d: "M.111.622C.144.611.119.475.121.311S.144.013.111,0,0,.123,0,.311.082.636.111.622",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4186",
    "data-name": "Group 4186",
    transform: "translate(67.208 236.211) rotate(134.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5114",
    "data-name": "Path 5114",
    d: "M.06.531C.094.531.121.412.12.265S.094,0,.06,0,0,.119,0,.265.027.531.06.531",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4187",
    "data-name": "Group 4187",
    transform: "matrix(-0.306, 0.952, -0.952, -0.306, 66.337, 235.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5115",
    "data-name": "Path 5115",
    d: "M.133.6C.163.579.119.454.121.3S.163.019.133,0,0,.107,0,.3.107.616.133.6",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4188",
    "data-name": "Group 4188",
    transform: "matrix(-0.346, 0.938, -0.938, -0.346, 65.298, 235.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5116",
    "data-name": "Path 5116",
    d: "M.06.32C.094.321.12.249.12.16S.094,0,.06,0,0,.071,0,.16.027.32.06.32",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4190",
    "data-name": "Group 4190",
    transform: "translate(64.56 233.144)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4189",
    "data-name": "Group 4189",
    transform: "matrix(0.999, -0.032, 0.032, 0.999, 0, 0.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5117",
    "data-name": "Path 5117",
    d: "M.069,1.2h9.948V0L0,.567Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4191",
    "data-name": "Group 4191",
    transform: "translate(87.601 230.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5118",
    "data-name": "Path 5118",
    d: "M-6.833.312-6.982-5l-9.953.215.135,7.774.618.026C-13.432,3.108-2.193,3.3-.37,2.7,1.665,2.034-6.833.312-6.833.312",
    transform: "translate(16.935 5.001)",
    fill: "#d3dffd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4193",
    "data-name": "Group 4193",
    transform: "translate(87.736 236.351)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4192",
    "data-name": "Group 4192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5119",
    "data-name": "Path 5119",
    d: "M-9.553-3.389S-6.57-2.6-6.93-2.1s-11.723.734-16.745.4l.011-.223,13.258-.165s.274-1.263.853-1.3",
    transform: "translate(23.675 3.389)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4194",
    "data-name": "Group 4194",
    transform: "translate(87.59 237.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5120",
    "data-name": "Path 5120",
    d: "M0,.178A.88.88,0,0,0,.171.193l.492.02,1.811.04C4,.275,6.116.279,8.45.232S12.9.1,14.422.011L16.229-.1l.491-.039a.905.905,0,0,0,.17-.021.858.858,0,0,0-.172,0l-.492.016-1.809.075c-1.527.058-3.637.134-5.97.181S4,.168,2.475.167H.172A.935.935,0,0,0,0,.178",
    transform: "translate(0 0.167)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4195",
    "data-name": "Group 4195",
    transform: "translate(101.683 236.086) rotate(30.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5121",
    "data-name": "Path 5121",
    d: "M.284,1.827A4.072,4.072,0,0,1,.121.915,4.092,4.092,0,0,1,.284,0,1.348,1.348,0,0,0,0,.914a1.334,1.334,0,0,0,.284.913",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4196",
    "data-name": "Group 4196",
    transform: "translate(98.494 235.507) rotate(31.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5122",
    "data-name": "Path 5122",
    d: "M.061.981A1.072,1.072,0,0,0,.122.49,1.055,1.055,0,0,0,.061,0,1.046,1.046,0,0,0,0,.49,1.043,1.043,0,0,0,.061.981",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4197",
    "data-name": "Group 4197",
    transform: "matrix(0.684, 0.73, -0.73, 0.684, 97.79, 235.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5123",
    "data-name": "Path 5123",
    d: "M.061.835C.094.835.121.648.122.418S.094,0,.061,0,0,.187,0,.417.027.835.061.835",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4198",
    "data-name": "Group 4198",
    transform: "translate(97.733 234.97) rotate(89.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5124",
    "data-name": "Path 5124",
    d: "M.06,1.04A1.175,1.175,0,0,0,.121.52,1.155,1.155,0,0,0,.06,0,1.183,1.183,0,0,0,0,.52a1.167,1.167,0,0,0,.06.52",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4199",
    "data-name": "Group 4199",
    transform: "translate(97.686 234.431) rotate(93.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5125",
    "data-name": "Path 5125",
    d: "M.014,1.181A1.014,1.014,0,0,0,.139.591,1.013,1.013,0,0,0,.014,0a3.271,3.271,0,0,0,0,.591,3.084,3.084,0,0,0,0,.591",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4200",
    "data-name": "Group 4200",
    transform: "translate(98.358 234.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5126",
    "data-name": "Path 5126",
    d: "M0,.937A1.864,1.864,0,0,0,.639.919,3.738,3.738,0,0,0,1.317.755,1.828,1.828,0,0,0,1.7.586a.346.346,0,0,0,.154-.2.252.252,0,0,0-.1-.254A1.175,1.175,0,0,0,.312.5a1.153,1.153,0,0,0-.2.431A.35.35,0,0,0,.1,1.108,1.807,1.807,0,0,1,.379.556,1.16,1.16,0,0,1,.919.19a.991.991,0,0,1,.763.036c.1.073.066.193-.045.263A1.959,1.959,0,0,1,1.28.65,4.361,4.361,0,0,1,.625.835C.243.911,0,.917,0,.937",
    transform: "translate(0 -0.015)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4201",
    "data-name": "Group 4201",
    transform: "translate(97.667 234.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5127",
    "data-name": "Path 5127",
    d: "M-.579,1.242A.632.632,0,0,0-.515.8,1.049,1.049,0,0,0-.7.333.642.642,0,0,0-1.238.017a.255.255,0,0,0-.191.3A.706.706,0,0,0-1.314.6,1.952,1.952,0,0,0-1,.981a.929.929,0,0,0,.371.251c.011-.016-.129-.112-.31-.311a2.219,2.219,0,0,1-.28-.378c-.091-.134-.156-.375,0-.407s.33.137.431.264A1.05,1.05,0,0,1-.6.811a2.362,2.362,0,0,1,.02.431",
    transform: "translate(1.435 -0.016)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4202",
    "data-name": "Group 4202",
    transform: "translate(87.737 235.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5128",
    "data-name": "Path 5128",
    d: "M0-4.508c0,.022.285-.033.736.011a3.213,3.213,0,0,1,1.618.627,3.213,3.213,0,0,1,1.032,1.4,6.967,6.967,0,0,1,.2.707.582.582,0,0,0,0-.2,2.629,2.629,0,0,0-.12-.534A3.081,3.081,0,0,0,2.426-3.96,3.082,3.082,0,0,0,.742-4.584,2.606,2.606,0,0,0,.2-4.558a.555.555,0,0,0-.2.05",
    transform: "translate(0 4.587)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4203",
    "data-name": "Group 4203",
    transform: "translate(88.776 235.013) rotate(179.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5129",
    "data-name": "Path 5129",
    d: "M.06,4.092A17.37,17.37,0,0,0,.12,2.047,17.238,17.238,0,0,0,.06,0,17.378,17.378,0,0,0,0,2.045,17.081,17.081,0,0,0,.06,4.092",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4204",
    "data-name": "Group 4204",
    transform: "translate(95.485 236.84) rotate(89.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5130",
    "data-name": "Path 5130",
    d: "M.013,2.909a5.66,5.66,0,0,0,.13-1.454A5.64,5.64,0,0,0,.013,0c-.035,0,.011.653.01,1.455S-.022,2.906.013,2.909",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4205",
    "data-name": "Group 4205",
    transform: "translate(90.993 237.438) rotate(154.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5131",
    "data-name": "Path 5131",
    d: "M.111.622C.143.611.119.475.121.312S.143.013.111,0,0,.123,0,.311.082.635.111.622",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4206",
    "data-name": "Group 4206",
    transform: "matrix(-0.697, 0.717, -0.717, -0.697, 90.293, 236.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5132",
    "data-name": "Path 5132",
    d: "M.061.531c.033,0,.06-.119.06-.266S.094,0,.061,0,0,.119,0,.265.027.531.061.531",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4207",
    "data-name": "Group 4207",
    transform: "translate(89.418 235.682) rotate(107.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5133",
    "data-name": "Path 5133",
    d: "M.132.6C.163.579.119.455.121.3S.162.019.132,0,0,.108,0,.3.106.616.132.6",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4208",
    "data-name": "Group 4208",
    transform: "translate(88.378 235.5) rotate(110.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5134",
    "data-name": "Path 5134",
    d: "M.061.321C.094.32.121.249.121.16S.094,0,.061,0,0,.072,0,.16.027.32.061.32",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4210",
    "data-name": "Group 4210",
    transform: "translate(87.63 233.247)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4209",
    "data-name": "Group 4209",
    transform: "translate(0 0.376) rotate(-2.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5135",
    "data-name": "Path 5135",
    d: "M.069,1.2h9.947V0L0,.567Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4211",
    "data-name": "Group 4211",
    transform: "translate(62.715 133.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5136",
    "data-name": "Path 5136",
    d: "M0-168.735V-68.082H15.691l1.388-87.3,5.5,87.3h15.69l-7.017-98.952Z",
    transform: "translate(0 168.735)",
    fill: "#1f3c88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4212",
    "data-name": "Group 4212",
    transform: "translate(79.694 134.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5137",
    "data-name": "Path 5137",
    d: "M-.97-17.615A8.689,8.689,0,0,1-.838-16c.043,1,.081,2.384.1,3.911.008.76.014,1.484.021,2.156a3.854,3.854,0,0,1-.326,1.766,2.06,2.06,0,0,1-.892.911.888.888,0,0,1-.474.131c-.008-.022.163-.063.412-.219a2.074,2.074,0,0,0,.759-.9A3.929,3.929,0,0,0-.989-9.927C-1-10.6-1.018-11.321-1.034-12.08c-.024-1.527-.029-2.911-.017-3.912A8.768,8.768,0,0,1-.97-17.615",
    transform: "translate(2.404 17.615)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4213",
    "data-name": "Group 4213",
    transform: "translate(77.874 134.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5138",
    "data-name": "Path 5138",
    d: "M-.3-1.967c.027.033-.21.157-.217.484a.507.507,0,0,0,.224.449A.6.6,0,0,0,.34-1.075a.408.408,0,0,0,.224-.344.408.408,0,0,0-.189-.365A.711.711,0,0,0-.259-1.92l-.008-.106c.129.06.194.1.187.121s-.088.015-.23-.011L-.436-1.94l.118-.083a.818.818,0,0,1,.852.063.682.682,0,0,1,.321.51.669.669,0,0,1-.339.594.889.889,0,0,1-.972.02A.664.664,0,0,1-.725-1.5a.625.625,0,0,1,.248-.41c.1-.066.172-.07.18-.057",
    transform: "translate(0.736 2.114)",
    fill: "#375a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4214",
    "data-name": "Group 4214",
    transform: "translate(48.284 113.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5139",
    "data-name": "Path 5139",
    d: "M-27.836-24.567c-.413-.538-5.369.316-5.369.316l1.808-1.371c-.92-1.634-4.105.344-5.118,1.3a1.864,1.864,0,0,0-.5.985L-57.01-19.12l-11.161-1.137s-.223,1.925-.784,5.557c-.529,3.432,5.118,6.8,8.615,6.307,3.2-.45,22.74-6.006,26.065-6.955h0l.484-.138-.008-.022c1.078-.371,3.654-1.293,3.924-1.76.341-.59.249-5.22.249-5.22l1.835-.809a1.314,1.314,0,0,0-.046-1.271",
    transform: "translate(68.99 26.248)",
    fill: "#ffbf9d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsEmptyState);
export default __webpack_public_path__ + "static/media/metrics_empty_state.8e3170bd4ac80a5dd624843e52b1e543.svg";
export { ForwardRef as ReactComponent };